<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
	// @ is an alias to /src
	import HelloWorld from "@/components/HelloWorld.vue";

	export default {
		name: "home",
		data() {
			return {
				authcode: '',
				appkey: '',
			};
		},
		watch: {
//			'$route' (to, from) {
//				console.log(this.$route.query);
//				if(sessionStorage.userid == undefined || sessionStorage.userid == '' || sessionStorage.userid == null) {
//					this.authcode = this.$route.query.authcode;
//					this.appkey = this.$route.query.appkey;
//					sessionStorage.setItem("authcode", this.authcode);
//					sessionStorage.setItem("appkey", this.appkey);
//					this.getToken();
//				}
//			}
		},
		components: {},
		mounted: function() {
			var res = 1;
			// console.log(res);
		},
		created: function() {

			// console.log(this.$route);
			//打包之前注释
			//			sessionStorage.setItem("token", "0bIiVgKwITzV8O/waiES+ySqTiO3qcn81xwjiblF61E2/Qq9K2RRh3XhLlXNeFkK");
			//			sessionStorage.setItem("userid", "34");
			//			sessionStorage.setItem("appkey", "lfgeapjv350cz9d7t6xq1r2bkym8wnsu");
		},
		methods: {
			getToken: function() {
//				console.log(this.appkey)
				let self = this;
				this.$axios.post("/Authapi/authToken", {
					appkey: this.appkey,
				}).then(function(res) {
					console.log(res.data);
					if(res.data.code == 2000) {
						
						sessionStorage.setItem("token", res.data.data.token);
							self.getUserInfo();
//							console.log(555555555555);					
					}
				}).catch(function(err) {
					console.log(err);
				});
			},
			getUserInfo: function() {
				let self = this;
				this.$axios.post("/v2/getMemberInfo", {
					appkey: this.appkey,
					token: sessionStorage.token,
					sign: $.md5(
						sessionStorage.token + sessionStorage.appkey + self.appsecret
					),
					authcode: sessionStorage.authcode
				}).then(function(res) {
					console.log(res.data);
					if(res.data.code == 2001) {
						sessionStorage.setItem("userid", res.data.data.userid);
//						console.log(333333333);
					}
				}).catch(function(err) {
					console.log(err);
				});
			}
		}
	};
</script>

<style lang="less">
	body,
	html {
		height: 100%;
	}
	
	#app {
		background: #f7f9fa;
		max-width: 500px;
		margin: 0 auto;
		min-height: 100vh;
		position: relative;
	}
	
	// 弹框css
	.model {
		z-index: 998;
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		.modelDiv {
			background: rgba(248, 248, 248, 1);
			border-radius: 13px;
			width: 72%;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			padding: 18px 0 0 0;
			h3 {
				font-size: 17px;
				color: #030303;
				text-align: center;
				line-height: 22px;
			}
			h4 {
				font-size: 13px;
				color: #030303;
				text-align: center;
				line-height: 20px;
				margin: 18px 0 23px 0;
			}
			p {
				border-top: 1px solid #ccccd0;
				span {
					box-sizing: border-box;
					font-size: 17px;
					color: #0076ff;
					text-align: center;
					width: 50%;
					float: left;
					height: 43px;
					line-height: 43px;
					&:nth-of-type(1) {
						border-right: 1px solid #ccccd0;
					}
				}
			}
		}
	}
</style>